import * as React from "react";

export const Loading: React.FunctionComponent = () => {
  return (
    <div className="react-plp-loading__block react-plp-loading__block--is-active">
      <div className="react-plp-loading__spinner"></div>
    </div>
  );
};
